import {inject, Service} from '@angular/core'
import {KalpylatorWrapper} from '../model/kalpylator-wrapper'
import {KalpInput, TTypeOfKalp} from './kalp.service'
import {NGService} from './ng.service'

@Service()
export class KalpylatorFactory {
  private readonly ngService = inject(NGService)

  public getKalpylator(kalpInput: KalpInput, extraInterest = 0, name: TTypeOfKalp = 'new'): KalpylatorWrapper {
    return new KalpylatorWrapper(this.ngService, kalpInput, extraInterest, name)
  }
}
